import { forwardRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { StripeElementsOptions } from '@stripe/stripe-js';
import { useLaunchDarkly } from '../../../launchdarkly';
import StripePaymentElement from './stripe/StripePaymentElement';
import { fromPaymentMethod, useAppDispatch } from '../../../store';
import { BuiltInPaymentForm } from './buiilt-in/BuiltInPaymentForm';
import { LoadingProgress } from '../../../layout';

export const CardInformation = forwardRef((
  { accountId, enableSave, enableDelete }: {
    accountId: number;
    enableSave: boolean;
    enableDelete: boolean;
  },
  ref,
) => {
  const { flags } = useLaunchDarkly();
  const dispatch = useAppDispatch();
  const currentPaymentMethod = useSelector(fromPaymentMethod.selectOneByAccountId(accountId));
  const [paymentMethod, setPaymentMethod] = useState(currentPaymentMethod);
  const stripePaymentConfig = useSelector(fromPaymentMethod.selectStripePaymentConfig);
  const [options, setOptions] = useState<StripeElementsOptions | undefined>(undefined);
  const [isLoadingClientSecret, setIsLoadingClientSecret] = useState(false);

  useEffect(() => {
    if (flags?.usingStripeSetupIntent) {
      setIsLoadingClientSecret(true);
      dispatch(fromPaymentMethod.doGetClientSecret())
        .finally(() => setIsLoadingClientSecret(false));
    }
  }, [flags?.usingStripeSetupIntent, dispatch]);

  useEffect(() => {
    const getPaymentMethod = async () => {
      if (accountId) {
        await dispatch(fromPaymentMethod.doGetPaymentMethod(accountId));
      }
    };
    getPaymentMethod().catch(() => {
    });
  }, [accountId, dispatch]);

  useEffect(() => {
    setPaymentMethod(currentPaymentMethod);
  }, [currentPaymentMethod]);

  useEffect(() => {
    if (stripePaymentConfig !== undefined && stripePaymentConfig !== null && !options) {
      setOptions({
        clientSecret: stripePaymentConfig.clientSecret,
        customerSessionClientSecret: stripePaymentConfig.customerSessionClientSecret,
        appearance: {
          theme: 'stripe',
        },
      });
    }
  }, [stripePaymentConfig, options]);

  return (
    <>
      {flags?.usingStripeSetupIntent
        ? (
          isLoadingClientSecret || !options
            ? <LoadingProgress fullscreen />
            : <StripePaymentElement options={options} />
        )
        : (
          <BuiltInPaymentForm
            ref={ref}
            accountId={accountId}
            enableSave={enableSave}
            enableDelete={enableDelete}
            currentCard={paymentMethod}
          />
        )}
    </>
  );
});
